import { ApolloLink } from "@apollo/client";
import { md5 } from "@crehana/utils";
const operationNameLink = (pageKey)=>new ApolloLink((operation, forward)=>{
        if (operation.operationName) {
            const { operationName, query, variables } = operation;
            const h = {
                'graphql-operation-type': 'query',
                'graphql-operation-name': operationName
            };
            const graphqlOperationDefinition = query.definitions.find((d)=>'OperationDefinition' === d.kind);
            if (graphqlOperationDefinition) h['graphql-operation-type'] = graphqlOperationDefinition.operation;
            if (pageKey) h['graphql-operation-source'] = pageKey;
            if (process.env.CREHANA_MICROFRONTEND_NAME) h['graphql-application-name'] = process.env.CREHANA_MICROFRONTEND_NAME;
            try {
                h['graphql-operation-id'] = md5(unescape(decodeURIComponent(JSON.stringify({
                    operationName,
                    variables
                }))));
            } catch (e) {
                console.error('Falied to stringify operationid', e);
            }
            operation.setContext(({ headers = {} })=>({
                    headers: {
                        ...headers,
                        ...h
                    }
                }));
        }
        return forward(operation);
    });
const links_operationNameLink = operationNameLink;
export default links_operationNameLink;
